
import { IconButton } from '@chakra-ui/react';
import React from 'react';
import { BsExclamationCircleFill } from 'react-icons/bs';
import { Tooltip } from '@packages/chakra-v3';
import { useTranslations } from 'next-intl';

const PromotionTooltip = () => {
	const t = useTranslations();

	return (
		<Tooltip content={t('Promotion.discountCondition')}>
			<IconButton
				aria-label={'Info'}
				size={'md'}
				variant={'ghost'}
				w={'fit-content'}
			>
				<BsExclamationCircleFill />
			</IconButton>
		</Tooltip>
	);
};

export default PromotionTooltip;